import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Avatar, Box, Button, Flex, Menu, MenuButton, MenuItem, MenuList, Spacer, useDisclosure, useToast } from "@chakra-ui/react";
import { BiHelpCircle } from "react-icons/bi";
import { HiOutlineChevronDown } from "react-icons/hi";
import { MdOutlineLogout } from "react-icons/md";

import { ModalBox } from "../../../shared/components";
import { useAuth } from "../auth/hooks";

function AdminNavbar() {
  const { user, setUser } = useAuth();
  const [confirm, setConfirm] = useState<boolean>(false);
  const navigate = useNavigate();
  const toast = useToast();
  const {
    isOpen: isLogOutOpen,
    onOpen: onLogOutOpen,
    onClose: onLogOutClose,
  } = useDisclosure();

  const [loading, setLoading] = useState(false);
  const handleLogout = () => {
    localStorage.removeItem("user");
    toast.closeAll();
    toast({
      title: "Success",
      description: "Logout Successfully",
      status: "success",
      isClosable: true,
      duration: 2000,
    });

    setUser(null);
    navigate("/admin/login", { replace: true });
  };

  

  useEffect(() => {
    if (confirm) {
      handleLogout();
      setConfirm(false);
    }
  },
   [confirm]
   );

  return (
    <Box py="4" px="2" bg="#0987A0">
      <Flex
        direction="row"
        flexWrap={{
          md: "nowrap",
          base: "wrap",
        }}
        justifyContent="space-between"
        alignItems="center"
        gap="5"
      >
        <Box
          textTransform="capitalize"
          display={{
            md: "block",
            base: "none",
          }}
          color="white"
        >
            Welcome : &nbsp;
          <span
            style={{
              textTransform: "capitalize",
              fontWeight: "500",
            }}
          >
            {user?.full_name.toLowerCase()}
          </span>
          &nbsp; &nbsp; &nbsp; Role Level :
          <span
            style={{
              textTransform: "capitalize",
              fontWeight: "500",
            }}
          >
            &nbsp;{" "}
            {user?.role
              ?.replaceAll("_", " ")
              ?.toLowerCase() ?? "Admin"}
          </span>
        </Box>
        <Spacer />

        {/* <ToggleLanguage /> */}

        <Menu>
          <MenuButton
            height={10}
            size="sm"
            as={Button}
            rightIcon={<HiOutlineChevronDown />}
            p={0}
          >
            <Flex
              gap={2}
              m={0}
              flex={1}
              px={0}
              alignItems="center"
              justifyContent={"space-between"}
            >
              <Avatar size={"sm"} src={user?.user_profile_image}/>

              <span
                style={{
                  padding: "100",
                  textAlign: "start",
                  textTransform: "capitalize",
                  width: "100%",
                  fontSize: "16px",
                  fontWeight: "500",
                }}
              >
                {user?.user_name?.toLowerCase()}
              </span>
               
            </Flex>
          </MenuButton>
          <MenuList>
            <MenuItem icon={<BiHelpCircle />}>
              Help
            </MenuItem>
            <MenuItem
              icon={<MdOutlineLogout />}
              onClick={() => {
                onLogOutOpen();
              }}
            >
              Logout
            </MenuItem>
          </MenuList>
        </Menu>
      </Flex>
      <ModalBox
        isOpen={isLogOutOpen}
        handleClose={onLogOutClose}
        handleOpen={onLogOutOpen}
        title="Logout"
        type="logout"
        size="sm"
        confirm={confirm}
        setConfirm={setConfirm}
        isLoading={loading}
      />
    </Box>
  );
};

export default AdminNavbar;
